<template>
  <div style="padding: 0 16px 16px;">
    <el-tree default-expand-all :data="dataArray"  node-key="id" ref="tree" :props="defaultProps" style="line-height: 26px;">
      <template #default="{ node, data }">
        <span class="custom-tree-node">
          <span v-if="node.level == 2">• </span>
          <span :class="node.level == 1?'level-1':node.level == 2?'level-2':''">{{ node.label }}</span>
        </span>
      </template>
    </el-tree>
  </div>
</template>

<script>


export default {
name: "RoleUserList",
  props: {
    value: Object
  },
  data() {
    return {
      menuList: this.value.menuList,
      dataArray: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
    }
  },
  methods: {
    show(node, data) {
      console.log(node)
      console.log('iiiii----------iiiiii')
      console.log(data)
    },

    getPage() {
      let ids = [];
      this.menuList.map(item => {
        ids.push(item.id)
      })
      let arr = JSON.parse(localStorage.getItem('menuLockList'))
      for(let i=0; i<arr.length; i++) {
        if(ids.indexOf(arr[i].id) == -1) {
          arr.splice(i, 1)
          i -= 1
        }else if(arr[i].children && arr[i].children.length > 0) {
          for(let j=0; j<arr[i].children.length; j++) {
            if(ids.indexOf(arr[i].children[j].id) == -1) {
              arr[i].children.splice(j, 1)
              j -= 1
            }
          }
        }
      }
      this.dataArray = arr
    }
  },
  mounted() {
    this.getPage()
  }
}
</script>

<style scoped>
.level-1 {
  font-weight: bold;
}
.level-2 {
  color: #606266;
}
</style>
